import React from "react"
import "./sidebar.css"
import dashboardlogo from "../../img/Luxterior (1).png"
import { RxDashboard } from "react-icons/rx"
import { MdDesignServices } from "react-icons/md"
import { BiGitPullRequest } from "react-icons/bi"
import { BsClipboardData } from "react-icons/bs"
import { MdOutlineAccountBalanceWallet, MdOutlinePayment } from "react-icons/md"
import { LuHelpCircle } from "react-icons/lu"
import { BiTrashAlt } from "react-icons/bi"
import { CgLogOut } from "react-icons/cg"
import { useNavigate } from "react-router-dom"
import { NavLink } from "react-bootstrap"
import { logout } from "../../services/slices/profile"
import { useAppDispatch } from "../../app/hooks"
import headerimage from "../../img/header-image.png"

const SideBar = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  return (
    <div className="dashboard-nav">
      <div className="dashboard-logo" onClick={() => navigate("/")}>
        <img src={dashboardlogo} />
      </div>

      <img
        src={headerimage}
        alt="Header"
        onClick={() => navigate("/dash/account")}
        className="m-auto"
      />

      <div className="dashboard-navbar">
        <ul>
          <li>
            <NavLink onClick={() => navigate("/dash/main")}>
              <RxDashboard /> Dashboard
            </NavLink>
          </li>
          {/*
            <li>
              <NavLink>Calculator</NavLink>
            </li>
          */}
          <li>
            <NavLink onClick={() => navigate("/dash/experts")}>
              <MdDesignServices />
              Designers
            </NavLink>
          </li>
          <li>
            <NavLink onClick={() => navigate("/dash/requests?type=tickets")}>
              <BiGitPullRequest />
              Active Requests
            </NavLink>
          </li>
          <li>
            <NavLink onClick={() => navigate("/dash/account")}>
              <MdOutlineAccountBalanceWallet />
              My Account
            </NavLink>
          </li>
          <li>
            <NavLink onClick={() => navigate("/dash/payment")}>
              <MdOutlinePayment />
              Payment Plans
            </NavLink>
          </li>
          <li>
            <NavLink onClick={() => navigate("/dash/transactions")}>
              <BsClipboardData />
              Transactions
            </NavLink>
          </li>
          <li>
            <NavLink onClick={() => navigate("/dash/help")}>
              <LuHelpCircle />
              Help & Support
            </NavLink>
          </li>
          <li>
            <NavLink onClick={() => navigate("/dash/trash")}>
              <BiTrashAlt />
              Trash
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={() => {
                dispatch(logout())
                navigate("/")
              }}
            >
              <CgLogOut />
              Log out
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default SideBar
